import { useState } from "react";
import { API } from "@/lib/api";
import { cn } from "@/lib/utils";

/**
 * Display a supplier visual: tries real logo from /api/suppliers/:slug/logo,
 * falls back to a colored square with the initial when logo is missing.
 */
export default function SupplierAvatar({ slug, name, size = "md", className }) {
    const [errored, setErrored] = useState(false);

    const sizeMap = {
        xs: "h-7 w-7 text-sm",
        sm: "h-9 w-9 text-base",
        md: "h-12 w-12 text-xl",
        lg: "h-16 w-16 text-3xl",
    };
    const klass = sizeMap[size] || sizeMap.md;
    const letter = (name || "?").charAt(0).toUpperCase();

    if (errored || !slug) {
        return (
            <div
                className={cn(
                    "rounded-xl bg-secondary flex items-center justify-center font-display font-black text-primary shrink-0",
                    klass,
                    className,
                )}
                aria-label={`Avatar ${name}`}
                data-testid={`avatar-${slug}`}
            >
                {letter}
            </div>
        );
    }

    return (
        <div
            className={cn(
                "rounded-xl bg-white flex items-center justify-center overflow-hidden border border-border shrink-0",
                klass,
                className,
            )}
            data-testid={`logo-${slug}`}
        >
            <img
                src={`${API}/suppliers/${slug}/logo`}
                alt={`Logo ${name}`}
                onError={() => setErrored(true)}
                className="max-w-[80%] max-h-[80%] object-contain"
                loading="lazy"
            />
        </div>
    );
}
